import { render, staticRenderFns } from "./FbTemplate.vue?vue&type=template&id=6e6b9ab8&scoped=true"
import script from "./FbTemplate.vue?vue&type=script&lang=js"
export * from "./FbTemplate.vue?vue&type=script&lang=js"
import style0 from "./FbTemplate.vue?vue&type=style&index=0&id=6e6b9ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6b9ab8",
  null
  
)

export default component.exports